import { AppraiseStageType } from './AppraiseStageType';

export const AppraiseStageOptions = [
    {
        id: AppraiseStageType.Order,
        name: 'Order',
    },
    {
        id: AppraiseStageType.Receive,
        name: 'Recieve',
    },
    {
        id: AppraiseStageType.Review,
        name: 'Order',
    },
];
